import { useEffect, useState } from 'react';
import DisplayNamewithLeftBorder from '../../common/DisplayNamewithLeftBorder';
import CustomInputs from '../../common/Inputs';
import { Form } from 'react-bootstrap';
import { useError } from '../../../utils/context/ErrorContext';
import DateHelper from '../../../utils/DateHelper';
import NewSelectAuto from '../NewSelectAuto';
import apiHelper from '../../../utils/apiHelper';
import { TenantService } from '@propertelligent/client-api';
import { TextCss } from '../../GlobalCss/TextCss';
import SelectField from '../../../newComponents/form-fields/SelectField';

const MoveOutDetails = ({ moveOutDate,
    setMoveOutDate,
    moveOutReason,
    setMoveOutReason,
    isMoveOut,
    moveData,
    setMoveData
}) => {
    const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
    const getMoveOutReason = () => {
        apiHelper(TenantService.getApiTenantMoveMoveReasonTypes, { showNotification: false })
            .then((res) => {

                setMoveOutReason(res?.data?.success)
            }).catch((err) => { })
    }

    useEffect(() => {
        getMoveOutReason()
    }, [])
    return (

        <div className="moveOutDataContainer">
            <div className='d-flex flex-column gap-2'>
                <CustomInputs
                    type='date'
                    myClassName={"containerTextField"}
                    labelText={isMoveOut ? "Move Out Date" : "Move In Date"}
                    value={moveData?.moveOutDate ? DateHelper.formatDate(moveData?.moveOutDate) : ""}
                    onChange={(e) => {
                        setMoveData({
                            ...moveData,
                            moveOutDate: e.target.value
                        })
                        setErrors({ ...errors, moveOutDate: false })
                    }}
                    isError={errors.moveOutDate}
                    errorMessages={errorMessages.moveOutDate}
                />
            </div>

            <div className=''>
                <NewSelectAuto
                    label={isMoveOut ? "Move Out Reason" : "Move In Reason"}
                    disabled={undefined}
                    setDisabled={undefined}
                    selected={moveData?.moveOutReasonTypeId}
                    setSelected={(value) => {
                        setMoveData({
                            ...moveData,
                            moveOutReasonTypeId: value
                        })
                        setErrors({ ...errors, moveOutReason: false })
                    }}
                    setSelectedOption={undefined}
                    selectedOption={undefined}
                    data={moveOutReason}
                    title={"Wait till the data fetches"}
                    type="Reason for Moving"
                    error={errors.moveOutReasonTypeId}
                    setError={() => { }}
                    fromContractor={true}
                    errorMessage={errorMessages.moveOutReasonTypeId}
                    width='260px'
                />
                {errors.moveOutReason &&
                    <div style={{ marginTop: "8px" }}>
                        <p className="errorMessageStyles">{errorMessages.moveOutReason}</p>
                    </div>
                }
            </div>
        </div>
    )
}

export default MoveOutDetails